import { EnvironmentConfig } from './environment-config.model';

const envBaseUrl = 'bo.stillmandigital.com';

const coreApiBasePath = `https://${envBaseUrl}/backoffice-api`;
const coreApiWsBasePath = `wss://${envBaseUrl}/backoffice-api`;
const houseLpApiBasePath = `https://${envBaseUrl}/house-lp-api`;
const houseLpWsBasePath = `wss://${envBaseUrl}/house-lp-api`;
const zerohashApiBasePath = `https://${envBaseUrl}/zerohash-api`;
const zerohashWsBasePath = `wss://${envBaseUrl}/zerohash-api`;
const fineryMarketsApiBasePath = `https://${envBaseUrl}/finery-api`;
const principalRiskLpApiBasePath = `https://${envBaseUrl}/principal-risk-lp-api`;
const bBookLpApiBasePath = `https://${envBaseUrl}/b-book-lp-api`;
const bBookLpWsBasePath = `wss://${envBaseUrl}/b-book-lp-api`;
const hiddenRoadApiBasePath = `https://${envBaseUrl}/hidden-road-api`;
const mainBookLpApiBasePath = `https://${envBaseUrl}/main-book-lp-api`;
const mainBookLpWsBasePath = `wss://${envBaseUrl}/main-book-lp-api`;
const syntheticLpApiBasePath = `https://${envBaseUrl}/synthetic-lp-api`;
const fireblocksApiBasePath = `https://${envBaseUrl}/fireblocks-api`;
export const environment: EnvironmentConfig = {
  production: true,
  isBermuda: false,
  isQA: false,
  envBaseUrl,
  captchaEnabled: true,
  recaptchaSitekey: '6LcsrF8tAAAAAAbqXuEc3zpUy2ZrGJiK0vQxwPS6',
  googleSsoEnabled: true,
  googleClientId: '302174659507-k1mqvbbc9u551hbn8otpifnuq9abcvtp.apps.googleusercontent.com',
  coreApiBasePath,
  coreApiWsBasePath,
  houseLpApiBasePath,
  houseLpWsBasePath,
  zerohashApiBasePath,
  zerohashWsBasePath,
  fineryMarketsApiBasePath,
  principalRiskLpApiBasePath,
  bBookLpApiBasePath,
  bBookLpWsBasePath,
  hiddenRoadApiBasePath,
  mainBookLpApiBasePath,
  mainBookLpWsBasePath,
  syntheticLpApiBasePath,
  fireblocksApiBasePath,
};
